import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

interface StudentDataSheetSortModalProps {
  open: boolean;
  onClose: () => void;
  onSelectSortBy: (sortBy: "rollnumber" | "studentname") => void;
  isLoading?: boolean;
}

const StudentDataSheetSortModal: React.FC<StudentDataSheetSortModalProps> = ({
  open,
  onClose,
  onSelectSortBy,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  const handleSortSelection = (sortBy: "rollnumber" | "studentname") => {
    onSelectSortBy(sortBy);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#f8f9fb",
          borderBottom: "2px solid #e0e7ff",
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          {t("sort_by") || "Sort By"}
        </Typography>
        <IconButton onClick={onClose} size="small" disabled={isLoading}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Button
            variant="outlined"
            fullWidth
            size="large"
            onClick={() => handleSortSelection("rollnumber")}
            disabled={isLoading}
            sx={{
              py: 2,
              fontSize: "1rem",
              fontWeight: "medium",
              borderColor: "#3092e3",
              color: "#3092e3",
              "&:hover": {
                borderColor: "#1976d2",
                backgroundColor: "#e3f2fd",
              },
            }}
          >
            {t("roll_number") || "Roll Number"}
          </Button>

          <Button
            variant="outlined"
            fullWidth
            size="large"
            onClick={() => handleSortSelection("studentname")}
            disabled={isLoading}
            sx={{
              py: 2,
              fontSize: "1rem",
              fontWeight: "medium",
              borderColor: "#3092e3",
              color: "#3092e3",
              "&:hover": {
                borderColor: "#1976d2",
                backgroundColor: "#e3f2fd",
              },
            }}
          >
            {t("student_name") || "Student Name"}
          </Button>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, borderTop: "1px solid #e0e0e0" }}>
        <Button
          onClick={onClose}
          color="inherit"
          disabled={isLoading}
        >
          {t("cancel") || "Cancel"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StudentDataSheetSortModal;


